export default __webpack_public_path__ + "static/media/signal_7.0f32bc7e.mp3";